import { BidDomainInsertModelSchema } from '@mntn-dev/domain-types'
import type { ZodInfer } from '@mntn-dev/utility-types'

import { SelectBidOutputSchema } from './select-bid.models.ts'

export const CreateBidInputSchema = BidDomainInsertModelSchema.pick({
  projectId: true,
  status: true,
})

export type CreateBidInput = ZodInfer<typeof CreateBidInputSchema>

export const CreateBidOutputSchema = SelectBidOutputSchema

export type CreateBidOutput = ZodInfer<typeof CreateBidOutputSchema>
